import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { ACTIVOSFIJOS_LISTA, ACTIVOSFIJOS_NUEVO, ACTIVOSFIJOS_EDITAR, ACTIVOSFIJOS_REPORTES } from 'constants/codigosTransacciones'

import EditarPage from './editar'
import ListaPage from './lista'
import NuevoPage from './nuevo'
import ReportePage from './reporte'

export default function ActivoFijosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${ACTIVOSFIJOS_REPORTES}`} component={ReportePage} />
        <Route path={`/${ACTIVOSFIJOS_LISTA}`} component={ListaPage} />
        <Route path={`/${ACTIVOSFIJOS_NUEVO}`} component={NuevoPage} />
        <Route path={`/${ACTIVOSFIJOS_EDITAR}/:idActivoFijo`} component={EditarPage} />
      </Switch>
    </Suspense>
  )
}
